module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<a class="cityPreview" data-bind="attr:{href:link}">\r\n	<span class="h3">'+
((__t=(directionTitle))==null?'':__t)+
'</span>\r\n	<span class="cityPreview_img" style="background-image:url(\''+
((__t=( imageProxy(cover, {width:426,height:320}) ))==null?'':__t)+
'\')"></span>\r\n	<span class="cityPreview_label">\r\n		';
 if(!_.isEmpty(restTypes)) restTypes.each(function(restType) { 
__p+='\r\n			<i class="icon icon-rtype_i16_'+
((__t=(restType.get('id')))==null?'':__t)+
'" title="'+
((__t=(restType.get('name')))==null?'':__t)+
'"></i>\r\n		';
 }) 
__p+='\r\n	</span>\r\n	<span class="cityPreview_price" data-bind="toggle:formatedPrice" style="display:none;"><span>от</span> <span data-bind="text:formatedPrice" class="cityPreview_price_value"></span> <span class="rubl">руб.</span></span>\r\n</a>';
}
return __p;
};
